module.exports = __webpack_public_path__ + "media/images/challenges/sony-talent-league-edition-ii/mentors__06-74cf6f746f1fd4e18850d88fbd390126.jpg";